import { useEffect, useState } from "react";

// react-router-dom components
import { Link, useLocation, useNavigate } from "react-router-dom";

// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

// Authentication layout components
import BasicLayout from "layouts/authentication/components/BasicLayout";

// Images

import bg from "assets/images/bg2.png";
import { Button, FormControl } from "@mui/material";
import OTPInput from "react-otp-input";
import { setToStorage } from "helpers";
import { STORAGE_KEYS } from "helpers";
import { useAppDispatch } from "hooks/store";
import { temporaryToken } from "reducers/authSlice";
import { setCredentials } from "reducers/authSlice";
import { useOtpVerifyMutation } from "services/auth";
import ShowToast from "components/MDToast";
import Loader from "helpers/constants/Loader";
import { useResendOtpMutation } from "services/auth";
import { BorderClear, BorderColor } from "@mui/icons-material";
import useTranslation from "hooks/Translation";

const otpStyle = (isError) => ({
  width: "50px",
  height: "50px",
  "box-sizing": "border-box",
  margin: "0 auto",
  backgroundColor: "transparent",
  borderWidth: 0.5,
  borderRadius: 4,
  border: `1px solid ${isError ? "#D10000" : "#ced4da"}`, // Change border color dynamically
  outline: "none",
  textAlign: "center",
  fontSize: "18px",
});
export default function VerifyOtp() {
  // {
  //   state === "forgot"
  //     ? navigate("/authentication/reset-password")
  //     : state === "phone"
  //     ? navigate("/dashboard")
  //     : navigate("/authentication/profile-setup");
  // }
  const t = useTranslation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [optVerificationMutation, { isLoading }] = useOtpVerifyMutation();
  const [resendOtp] = useResendOtpMutation();

  const [otp, setOtp] = useState("");
  const location = useLocation();
  const { state } = location;
  const [error, setError] = useState(false);
  const [countDown, setCountDown] = useState(59);

  const handleSubmit = async () => {
    setError(true);
    if (otp?.length === 4) {
      setError(false);

      const body = {
        ...(state?.type === "phone"
          ? { phone_no: state?.key }
          : { email: state?.key }),
        ...(state?.type === "phone"
          ? { country_code: state?.countryCode }
          : {}),

        // ...(state?.page === "login" ? { deviceToken: fcm_token } : {}),
        // ...(state?.page === "login" ? { deviceType: "WEB" } : {}),
        otp: otp,
      };
      console.log(body, "body");

      try {
        const res = await optVerificationMutation(body).unwrap();
        if (res?.status === 200) {
          if (state?.page === "signUp") {
            setToStorage(STORAGE_KEYS.token, res?.data?.token);
            setToStorage(STORAGE_KEYS.userData, JSON.stringify(res?.data));
            dispatch(
              setCredentials({
                user: res?.data || "",
                token: res?.data?.token || "",
              })
            );
            navigate("/authentication/profile-setup", {
              state: state,
              replace: true,
            });
          } else if (state?.type === "profile") {
            navigate("/", { replace: true });
          } else if (state?.page === "forgot") {
            setToStorage(STORAGE_KEYS.token, res?.data?.token);
            dispatch(
              setCredentials({
                user: null,
                token: res?.data?.token || "",
              })
            );
            navigate("/authentication/reset-password", {
              state: {
                email: state?.key,

                replace: true,
              },
            });
          } else if (state?.page === "login") {
            console.log("state: /kkkkk", state);
            setToStorage(STORAGE_KEYS.token, res?.data?.token || "");
            dispatch(
              setCredentials({
                user: res?.data,
                token: res?.data?.token || "",
              })
            );

            navigate("/dashboard", { replace: true });
          } else {
            ShowToast("Login Successfully.");
            setToStorage(STORAGE_KEYS.token, res?.data?.token || "");
            setToStorage(STORAGE_KEYS.credentials, JSON.stringify(res?.data));
            dispatch(
              setCredentials({
                user: res?.data,
                token: res?.data?.token || "",
              })
            );
            navigate("/dashboard", { replace: true });
          }
        }
      } catch (error) {
        if (error?.data?.message) {
          ShowToast(error?.data?.message || "", "error");
        }
      }
    } else {
      setError(true);
    }
  };

  const handleResendOtp = async () => {
    let body = {
      ...(state?.type === "phone"
        ? { phone_no: state?.key }
        : { email: state?.key }),
      ...(state?.type === "phone" ? { country_code: state?.countryCode } : {}),
    };
    console.log("first", body);
    try {
      const response = await resendOtp(body).unwrap();
      if (response?.status === 200) {
        ShowToast(response?.message || "-");
        setCountDown(59);
      }
    } catch (error) {
      ShowToast(error?.data?.message || "", "error");
    }
  };

  useEffect(() => {
    if (countDown > 0) {
      setTimeout(() => {
        setCountDown(countDown - 1);
      }, 1000);
    } else {
      setCountDown(0);
    }
  }, [countDown]);

  return (
    <BasicLayout>
      <Grid
        container
        className="signin-container"
        sx={{ overflow: "hidden", minHeight: "100vh" }}
      >
        {/* Image Section */}
        <Grid
          item
          xs={0}
          md={6}
          sx={{
            display: { xs: "none", md: "block" },
            position: "relative",
            background: "black",
            height: "100vh",
          }}
        >
          <img
            src={bg}
            alt="Sign In"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              marginTop: "-2px",
            }}
          />
        </Grid>

        {/* Form Section */}
        <Grid
          item
          xs={12}
          md={6}
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            px: { xs: 4, sm: 8 },
          }}
        >
          {/* <Card> */}
          <MDBox sx={{ maxWidth: 500, width: "100%" }} pt={5}>
            <MDBox
              // variant="gradient"
              // bgColor="#2B604C"
              borderRadius="lg"
              // coloredShadow="info"
              mx={2}
              // mt={-3}
              // p={2}
              mb={1}
              textAlign="center"
            >
              <MDTypography variant="h4" fontWeight="medium" mt={1}>
                {t.auth.enterOtp}
              </MDTypography>

              <MDTypography variant="body2" mt={1}>
                {t.auth.otpSentTo}
              </MDTypography>
              <MDTypography variant="body2" mt={1}>
                {state?.type === "phone"
                  ? `${state?.countryCode} ${state?.key}`
                  : `${state?.key}`}
              </MDTypography>
            </MDBox>
            <MDBox pt={4} pb={3} px={3}>
              <MDBox component="form" role="form">
                <FormControl className="opt_fields" sx={{ width: "100%" }}>
                  <OTPInput
                    containerStyle={{ width: "70%", margin: "auto" }}
                    value={otp}
                    onChange={setOtp}
                    numInputs={4}
                    renderInput={(props) => (
                      <input {...props} style={otpStyle(error)} />
                    )}
                    // inputStyle={otpStyle}
                    inputType="tel"
                  />
                </FormControl>

                {error && (
                  <MDTypography
                    variant="body2"
                    sx={{ color: "#D10000", textAlign: "center", mt: 1 }}
                  >
                    {otp.length === 0 ? "Please enter OTP" : "Invalid OTP"}
                  </MDTypography>
                )}

                <MDBox mt={4} mb={1}>
                  <MDButton
                    onClick={() => handleSubmit()}
                    variant="gradient"
                    color="success"
                    fullWidth
                  >
                    {t.auth.verify}
                  </MDButton>
                </MDBox>
                {countDown === 0 ? (
                  <MDBox
                    mt={3}
                    mb={1}
                    textAlign="center"
                    sx={{ cursor: "pointer" }}
                  >
                    <Button
                      onClick={() => handleResendOtp()}
                      style={{ color: "#2B604C" }}
                    >
                      {t.auth.resendOtp}
                    </Button>
                    {/* <MDTypography
                      mt={1}
                      sx={{ textDecoration: "underline", cursor: "pointer" }}
                      variant="button"
                      fontWeight="bold"
                      onClick={() => handleResendOtp()}
                    >
                      Resend OTP
                    </MDTypography> */}
                  </MDBox>
                ) : (
                  <MDBox mt={2}>
                    <MDTypography
                      variant="body2"
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      {t.auth.codeExpire}{" "}
                      <MDTypography
                        sx={{
                          margin: 0,
                          color: "black",
                          paddingLeft: 3,
                          minWidth: 70,
                        }}
                        variant="body2"
                      >
                        {countDown < 10
                          ? `00: 0${countDown}`
                          : `00: ${countDown}`}
                      </MDTypography>
                    </MDTypography>
                  </MDBox>
                )}
              </MDBox>
            </MDBox>
          </MDBox>

          {/* </Card> */}
        </Grid>
      </Grid>
      <Loader loading={isLoading} />
    </BasicLayout>
  );
}
